module.exports = __webpack_public_path__ + "static/media/semanaCiencia.8e9a84a9.jpg";